exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flex-jcsb-aic[data-v-40e8a62e] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n", ""]);

// exports
